import { type ReactNode } from 'react'
import { cn } from '../../../lib/cn.ts'

interface HeaderProps {
  sidebarCollapsed: boolean
  /** Opens the mobile (< md) off-canvas drawer. */
  onOpenMobile?: () => void
  right?: ReactNode
}

export function Header({ sidebarCollapsed, onOpenMobile, right }: HeaderProps) {
  return (
    <header
      className={cn(
        'flex h-[64px] shrink-0 items-center justify-between gap-3 px-4 sm:px-6 md:justify-end',
        'transition-[margin-left] duration-300 ease-in-out',
        // Full-width on mobile; the sidebar margin only applies at md+.
        'ml-0',
        sidebarCollapsed
          ? 'md:ml-[var(--sidebar-width-collapsed)]'
          : 'md:ml-[var(--sidebar-width-expanded)]',
      )}
    >
      {/* Hamburger — opens the drawer; mobile only (the rail is persistent at md+). */}
      <button
        type="button"
        onClick={onOpenMobile}
        aria-label="Open menu"
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-md md:hidden',
          'text-foreground transition-colors hover:bg-background-secondary',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        )}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {right}
    </header>
  )
}
